import { render, staticRenderFns } from "./PrivacyTabGeneral.vue?vue&type=template&id=20a32ed8"
import script from "./PrivacyTabGeneral.vue?vue&type=script&lang=js"
export * from "./PrivacyTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports